import { gql } from "@apollo/client";

const ACCOUNT_LIST_QUERY_V2 = gql`
  query accountsV2($first: Int, $after: String, $last: Int, $before: String) {
    accountsV2(first: $first, after: $after, last: $last, before: $before) {
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      edges {
        node {
          name
          urlName
        }
      }
    }
  }
`;

const ACCOUNT_DETAILS = gql`
  query account($urlName: String!) {
    account(urlName: $urlName) {
      name
      urlName
      defaultDeadline
      dailySummaryTime
      dailySummaryRecipients
      users {
        email
        name
        roles
      }
      contractedRowCount
      showDownloadSummary
    }
  }
`;

const VERIFY_EMAIL = gql`
  query verifyEmail($email: String!) {
    verifyEmail(email: $email) {
      auth0Name
      userId
      useIdP
    }
  }
`;

export { ACCOUNT_DETAILS, ACCOUNT_LIST_QUERY_V2, VERIFY_EMAIL };
